<template>
    <!-- Main content -->
    <div class="rbt-main-content">
        <div class="rbt-daynamic-page-content">

            <!-- Dashboard Center Content -->
            <div class="rbt-dashboard-content">
                <div class="content-page">
                    <template v-if="idArtefato == 0">
                        <template v-if="flRealizaArtefato">

                            <!-- nao pode realizar novo -->
                            <template v-if="!(utilizacoes && utilizacoes.permiteRealizarArtefatos) && flVerificouUtilizacoes">
                                <div class="chat-box-list pt--30">
                                    <div class="chat-box ai-speech bg-flashlight box-anime">
                                        <div class="inner top-flashlight leftside light-xl">
                                            <div class="chat-section">
                                                <div class="author">
                                                    <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                                </div>
                                                <div class="chat-content">
                                                    <h6 class="title">
                                                        SollAI
                                                    </h6>
                                                    <p class="mb--20">
                                                        Desculpe, parece que você atingiu seu limite de Artefatos do contrato.
                                                        Entre em contato com um dos nossos consultores.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <!-- LEGISLACAO -->
                            <div class="chat-box-list pt--30">
                                <div class="chat-box ai-speech bg-flashlight box-anime">
                                    <div class="inner top-flashlight leftside light-xl">
                                        <div class="chat-section">
                                            <div class="author">
                                                <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                            </div>
                                            <div class="chat-content">
                                                <h6 class="title">
                                                    SollAI
                                                </h6>
                                                <p class="mb--20">
                                                    <span id="negrito">Escolha a legislação:</span> (Baseado em qual lei deseja a reposta).
                                                </p>
                                                <div v-for="(item,index) in lstLegislacao" :key="index" class="mb-4">
                                                    <input type="radio" :id="'legislacao-'+item.idLegislacaoModeloArtefato" name="idLegislacaoModeloArtefato" v-model="idLegislacaoModeloArtefato" :value="item.idLegislacaoModeloArtefato" />
                                                    <label class="gradient-text text-dark color-gradient" :for="'legislacao-'+item.idLegislacaoModeloArtefato">{{item.dsNome}} - {{item.dsLegislacao}}</label>
                                                </div>
                                                <div class="reaction-section">
                                                    <div class="btn-grp">
                                                        <div class="left-side-btn dropup">

                                                        </div>
                                                        <div class="right-side-btn">
                                                            <button class="react-btn btn-default btn-small btn-border btn-selecionar" @click="proximo(0)">
                                                                <span class="ms-0">Selecionar</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <!-- MODELO -->
                            <div class="chat-box-list pt--30" v-if="etapa > 0" ref="etapa1">
                                <div class="chat-box ai-speech bg-flashlight box-anime">
                                    <div class="inner top-flashlight leftside light-xl">
                                        <div class="chat-section">
                                            <div class="author">
                                                <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                            </div>
                                            <div class="chat-content">
                                                <h6 class="title">
                                                    SollAI
                                                </h6>
                                                <p class="mb--20"><span id="negrito">Escolha seus Artefatos:</span> Selecione artefatos específicos que deseja produzir.</p>
                                                <template v-if="lstModelos.length > 0">
                                                    <template v-if="flTemModelos">
                                                        <div v-for="(item,index) in lstModelos" :key="index" class="mb-4">
                                                            <template v-if="item.lstModeloArtefato.length > 0">
                                                                <h5 class="h5-gradient">• {{item.modeloArtefatoFase.dsNome}}</h5>
                                                                <div v-for="(item2,index2) in item.lstModeloArtefato" :key="index2">
                                                                    <input type="radio" :id="'modelo-'+item2.modeloArtefato.idModeloArtefato" name="artefatos1" v-model="idModelo" :value="item2.modeloArtefato.idModeloArtefato" />
                                                                    <label class="gradient-text text-dark color-gradient" :for="'modelo-'+item2.modeloArtefato.idModeloArtefato"
                                                                           :data-bs-toggle="(item2.modeloArtefato.dsModelo != null?'popoverModelo':'')" data-bs-placement="top" title="Detalhes" :data-bs-content="getDataBs(item2)">{{item2.modeloArtefato.nmModelo}}</label>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <span>Nenhum modelo encontrado para a legislação selecionada.</span>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <span>Nenhum modelo encontrado para a legislação selecionada.</span>
                                                </template>


                                                <br>

                                                <!--<h5 class="h5-gradient">• Fase Externa</h5>
                        <div>
                            <input type="radio" id="artefato09" name="artefatos9" value="artefato09" />
                            <label class="gradient-text text-dark" for="artefato09">Ata de Registro de Preços</label>
                        </div>
                        <br>-->
                                                <!--<h5 class="h5-gradient">• Contratos</h5>
                        <div>
                            <input type="radio" id="artefato14" name="artefatos14" value="artefato14" />
                            <label class="gradient-text text-dark" for="artefato14">Termo de contrato – Serviços SEM dedicação exclusiva de mão de obra – Contratação direta</label>
                        </div>-->

                                                <div class="reaction-section">
                                                    <div class="btn-grp">
                                                        <div class="left-side-btn dropup">

                                                        </div>
                                                        <div class="right-side-btn">
                                                            <button class="react-btn btn-default btn-small btn-border btn-selecionar" @click="proximo(1)">
                                                                <span class="ms-0">Selecionar</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <!-- ARQUIVO -->
                            <div class="chat-box ai-speech bg-flashlight box-anime" v-if="etapa > 1" ref="etapa2">
                                <div class="inner top-flashlight leftside light-xl">
                                    <div class="chat-section">
                                        <div class="author">
                                            <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                        </div>
                                        <div class="chat-content">
                                            <h6 class="title">
                                                SollAI
                                            </h6>
                                            <p class="mb--20">
                                                Gostaria de me ajudar a produzir o esboço?
                                            </p>
                                            <p>Envie aqui as informações que você já possui sobre a contratação </p>
                                            <p>(Exemplo: descrição do objeto ou serviço que deseja licitar; um processo anterior já realizado; pesquisa de preços; etc)</p>
                                            <label for="myfile"></label>
                                            <input type="file" id="myfile" name="myfile" accept=".pdf,.doc,.docx">

                                            <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :useCustomSlot=true v-if="false">
                                                <div class="dropzone-custom-content">
                                                    <h3 class="dropzone-custom-title">Arraste e solte para enviar conteúdo!</h3>
                                                    <div class="subtitle">...ou clique para selecionar um arquivo do seu computador</div>
                                                </div>
                                            </vue-dropzone>

                                            <div class="reaction-section">
                                                <div class="btn-grp">
                                                    <div class="left-side-btn dropup">

                                                        <ul class="dropdown-menu">

                                                            <li>
                                                                <a class="dropdown-item" href="#"><i class="feather-file-text"></i> Renomear</a>
                                                            </li>
                                                            <li>
                                                                <a class="dropdown-item" href="#"><i class="feather-file-text"></i> Baixar PDF</a>
                                                            </li>
                                                            <li>
                                                                <a class="dropdown-item" href="#"><i class="feather-file-text"></i> Baixar Word</a>
                                                            </li>
                                                            <li>
                                                                <a class="dropdown-item" href="#"><i class="feather-file-text"></i> Baixar PDF</a>
                                                            </li>
                                                            <li>
                                                                <a class="dropdown-item" href="#"><i class="feather-file-text"></i> Baixar Word</a>
                                                            </li>
                                                            <!-- <li><a class="dropdown-item delete-item" href="#"><i class="feather-trash-2"></i> Deletar
                                        Chat</a>
                                    </li> -->
                                                        </ul>
                                                    </div>
                                                    <div class="right-side-btn" v-if="utilizacoes && utilizacoes.permiteRealizarArtefatos">
                                                        <button class="react-btn btn-default btn-small btn-border btn-selecionar" @click="proximo(2)">
                                                            <span class="ms-0">Enviar</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </template>
                        <template v-else-if="flVerificouRealizar">
                            <div class="chat-box-list pt--30">
                                <div class="chat-box chat-box-you author-speech bg-flashlight">
                                    <div class="inner">
                                        <div class="chat-section">
                                            <div class="author">
                                                <img class="w-100" src="assets/images/sollai/team-01.jpg" alt="Author">
                                            </div>
                                            <div class="chat-content">
                                                Aguarde a conclusão do artefato atual antes de realizar um novo.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <template v-else>

                        <div class="chat-box-list pt--30" v-if="artefato">
                            <div class="chat-box ai-speech bg-flashlight box-anime pt--30">
                                <div class="inner top-flashlight leftside light-xl">
                                    <div class="chat-section">
                                        <div class="author">
                                            <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                        </div>
                                        <div class="chat-content">
                                            <h6 class="title">
                                                SollAI
                                            </h6>
                                            <p class="mb--0" v-if="artefato.modelo">
                                                <strong>Modelo: </strong> <a class="c-pointer" href="javascript:void(0)" @click="download(artefato.modelo.urlArquivo)">{{artefato.nmModelo}}</a>
                                            </p>
                                            <p class="mb--0" v-if="artefato.urlArquivo">
                                                <strong>Fonte de dados: </strong> <a class="c-pointer" href="javascript:void(0)" @click="download(artefato.urlArquivo)">{{getNomeArquivo(artefato.urlArquivo)}}</a>
                                            </p>
                                            <p class="mb--0" v-if="legislacao">
                                                <strong>Legislação: </strong>
                                                <a href="javascript:void(0)" @click="openReferencia(legislacao.tpConteudo, legislacao.idConteudo)" v-if="!flImprimir">
                                                    {{legislacao.dsNome}}
                                                </a>
                                                <span v-else> {{legislacao.dsNome}}</span>
                                            </p>
                                            <p class="mb--0">
                                                <strong>Data da solicitação: </strong>{{artefato.dtInclusao}}
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br>

                        <div class="chat-box ai-speech bg-flashlight box-anime pt--30">
                            <div class="inner top-flashlight leftside light-xl">
                                <div class="chat-section">
                                    <div class="author">
                                        <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                    </div>
                                    <div class="chat-content">
                                        <h6 class="title">
                                            SollAI
                                        </h6>
                                        <template v-if="statusArtefato == 'Processando' || statusArtefato == 'Iniciada'">
                                            <p class="txt-p txt-blue-1 txt-size-20 txt-w-bold mb-2">
                                                {{mensagemProcessando}}
                                            </p>
                                            <p class="txt-p txt-grey-3 txt-size-14 txt-w-5 mb-2">
                                                Por favor, aguarde um momento enquanto eu processo seu artefato. Obrigado pela sua paciência e compreensão.
                                            </p>
                                            <div class="progress px-0 d-none">
                                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: '20%'}"></div>
                                            </div>

                                        </template>
                                        <template v-if="statusArtefato == 'Cancelada'">
                                            <span class="txt-erro txt-size-40">
                                                <i class="fas fa-exclamation-triangle txt-erro"></i>
                                            </span>
                                            <p class="txt-p txt-blue-1 txt-size-20 txt-w-bold mb-2">
                                                Erro ao processar o artefato
                                            </p>
                                            <p class="txt-p txt-blue-1 txt-size-16 txt-w-5 mb-2">
                                                {{msgErro}}
                                            </p>
                                        </template>
                                        <template v-if="statusArtefato == 'Finalizada'">
                                            <template vif="artefato">
                                                <p class="mb--20">Seu documento esta pronto!</p>
                                                <p>Faça o download do arquivo.</p>

                                                <div class="reaction-section">
                                                    <div class="btn-grp">
                                                        <div class="left-side-btn dropup">
                                                            <button data-bs-toggle="modal" data-bs-target="#shareModal"
                                                                    class="react-btn btn-default btn-small btn-border">
                                                                <i class="feather-share"></i>
                                                            </button>
                                                            <button type="button" class="react-btn btn-default btn-small btn-border dropdown-toggle d-none"
                                                                    data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i class="feather-more-vertical"></i>
                                                            </button>
                                                            <ul class="dropdown-menu">
                                                                <li>
                                                                    <a class="dropdown-item" href="#">
                                                                        <i class="feather-file-text"></i>
                                                                        Baixar PDF
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a class="dropdown-item" href="#">
                                                                        <i class="feather-file-text"></i>
                                                                        Baixar World
                                                                    </a>
                                                                </li>
                                                                <li><a class="dropdown-item" href="#"><i class="feather-file-text"></i>Imprimir</a></li>

                                                            </ul>
                                                        </div>
                                                        <div class="right-side-btn" v-if="artefato.documento">
                                                            <button class="react-btn btn-default btn-small btn-border btn-selecionar" @click="download(artefato.documento.urlArquivo,true)" v-if="artefato.documento.urlArquivo">
                                                                <span class="ms-0">Fazer Download</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-if="statusArtefato == 'Finalizada' && artefato">
                            <div class="chat-box ai-speech bg-flashlight box-anime pt--30" v-if="artefato.dsResposta">
                                <div class="inner top-flashlight leftside light-xl">
                                    <div class="chat-section">
                                        <div class="author">
                                            <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                        </div>
                                        <div class="chat-content">
                                            <h6 class="title">
                                                SollAI
                                            </h6>
                                            <template>

                                                <p v-if="artefato.dsResposta" class="mb--20 resposta" style="white-space: pre-line;">
                                                    {{artefato.dsResposta}}
                                                </p>


                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="d-flex justify-content-center ">
                            <button class="react-btn btn-default btn-small btn-border" @click="novo">
                                <span class="ms-0">Criar novo artefato</span>
                            </button>
                        </div>
                    </template>
                </div>
                <HistoricoArtefatos :seleciona="selecionaArtefato" :reload="reloadHistorico" :idArtefato="idArtefato"></HistoricoArtefatos>

            </div>
        </div>

        <ModalDetalhes :dados="modalDetalhes" :showModal="showModalDetalhes"></ModalDetalhes>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import HistoricoArtefatos from '@/components/HistoricoArtefatos'
    import moment from 'moment'
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import ModalDetalhes from '@/components/ModalDetalhes'

    export default {
        name: 'Artefato',
        components: { HistoricoArtefatos: HistoricoArtefatos, vueDropzone: vue2Dropzone, ModalDetalhes },
        props: {
            reload: Boolean,
            reloadNavegacao: Function,
        },
        computed: {
            hubConection() {
                return this.$store.state.hubConection
            },
        },
        data: function () {
            return {
                idArtefato: 0,
                lstModelos: [],

                idModelo: null,
                arquivo: null,
                etapa: 0,
                msgErro: null,
                flReprocessar: false,
                statusArtefato: null,
                artefato: null,
                reloadHistorico: false,

                dropzoneOptions: {
                    url: urlApi + '/Documento/EnviarDocumento',
                    maxFilesize: 0.5,
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    headers: { "My-Awesome-Header": "header value" }
                },

                flRealizaArtefato: false,
                utilizacoes: null,
                flVerificouUtilizacoes: false,
                mensagemProcessando: "Processando artefato...",
                flVerificouRealizar: false,

                lstLegislacao: [],
                idLegislacaoModeloArtefato: null,

                flTemModelos: null,
                legislacao: null,

                modalDetalhes: {
                    cdConteudo: null,
                    idItemPesquisa: null,
                    dsReferencia: null,
                },

                showModalDetalhes: false,

            }
        },
        methods: {
            selecionaArtefato(id) {
                this.idArtefato = id;
                this.load();
            },

            novo() {
                this.idArtefato = 0;
                this.etapa = 0;
                this.idModelo = null;
                this.arquivo = null;

                this.load();
            },

            load() {
                if (this.idArtefato != 0) {
                    this.carregaArtefato();
                }
                
                this.carregaLegislacoes();
                this.verificaRealizaArtefato();
                this.carregaUtilizacoes();
            },

            carregaModelos() {
                let $this = this;
                $this.lstModelos = [];
                axios.get(`${urlApi}/Modelo/GetFases`, { showLoading: false, params: { idLegislacaoModeloArtefato: $this.idLegislacaoModeloArtefato } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstModelos = res.data.data.rows;

                            let flTemModelos = false;
                            for (let i = 0; i < $this.lstModelos.length; i++) {
                                if ($this.lstModelos[i].lstModeloArtefato.length > 0) {
                                    flTemModelos = true;
                                }
                            }

                            $this.flTemModelos = flTemModelos;
                            $this.montaPopover();
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            carregaLegislacoes() {
                let $this = this;
                $this.lstLegislacao = [];
                axios.get(`${urlApi}/Legislacao/GetLegislacaoArtefato`, { showLoading: false, params: { } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstLegislacao = res.data.data;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            InitSignalR() {
                try {
                    let $this = this;
                    //var token = $this.user.accessToken;
                    //var connection = new window.signalR.HubConnectionBuilder().withUrl(`${urlSignal}notificacaohub?p_dsLogin=` + $this.user.usuario.dsLogin, { accessTokenFactory: () => token }).build();

                    $this.hubConection.on("RecebeNotificacaoArtefato", function (idArtefato, status, dtAtualizacao) {
                        if ($this.idArtefato == idArtefato) {
                            $this.load();
                        } else {
                            avisoToast('Status do artefato atualizado para ' + status + ' - ' + moment(dtAtualizacao).format('DD/MM/YYYY [às] HH:mm'));
                        }
                    });

                    $this.hubConection.on("AtualizaRealizarArtefato", function (flRealizaArtefato) {
                        $this.flRealizaArtefato = flRealizaArtefato == "Sim" || flRealizaArtefato == "true" ? true : false;
                    });

                    $this.hubConection.on("AtualizaStatusArtefato", function (idArtefato, status,) {
                        $this.mensagemProcessando = status;
                    });

                    //$this.hubConection.start().then(function () {
                    //    console.log('Connetado!');
                    //}).catch(function (err) {
                    //    return console.error('Erro: ', err.toString());
                    //});

                    ////$this.hubConection.disconnected(function () {
                    ////    setTimeout(function () {
                    ////        console.log('Tentando Reconectar!');
                    ////        $this.hubConection.hub.start();
                    ////    }, 5000);
                    ////});
                    //$this.hubConection.onclose(async () => {
                    //    setTimeout(function () {
                    //        console.log('Tentando Reconectar!');
                    //        $this.hubConection.hub.start();
                    //    }, 5000);
                    //});
                }
                catch (ex) {
                    console.log(ex);
                }
            },

            proximo(p_etapa) {
                switch (p_etapa) {
                    case 0:
                        if (this.idLegislacaoModeloArtefato) {
                            this.carregaModelos();
                            this.etapa = this.etapa + 1;

                            this.$nextTick(function () {
                                const el = this.$refs.etapa1;

                                if (el) {
                                    // Use el.scrollIntoView() to instantly scroll to the element
                                    el.scrollIntoView({ behavior: 'smooth' });
                                }
                            });
                        } else {
                            avisoToast("Selecione uma legislação", "warning");
                        }
                        
                        break;
                    case 1:
                        if (this.idModelo) {
                            
                            this.etapa = this.etapa + 1;
                            
                            this.$nextTick(function () {
                                const el = this.$refs.etapa2;

                                if (el) {
                                    // Use el.scrollIntoView() to instantly scroll to the element
                                    el.scrollIntoView({ behavior: 'smooth' });
                                }
                            });
                        } else {
                            avisoToast("Selecione um modelo", "warning");
                        }
                        break;


                    case 2:
                        if (document.querySelector("#myfile") != null) {
                            if (this.utilizacoes && this.utilizacoes.permiteRealizarArtefatos) {
                                this.enviarArtefato();
                            } else {
                                avisoToast("Desculpe, parece que você atingiu seu limite de Artefatos do contrato. Entre em contato com um dos nossos consultores.", "warning");
                            }
                        } else {
                            avisoToast("Selecione um arquivo", "warning");
                        }
                        break;

                    default:
                        break;
                }
            },

            enviarArtefato() {
                let $this = this;
                $this.statusArtefato = 'Processando';
                $this.disabled = true;

                const formData = new FormData();

                const inputFile = document.querySelector("#myfile");
                if (inputFile != null) {
                    formData.append("file", inputFile.files[0]);
                }
                formData.append("idModelo", $this.idModelo);

                axios.post(`${urlApi}/artefato/post`, formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, } })
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Artefato registrado com sucesso, acompanhe a situação no campo status da listagem.");
                            $this.reloadHistorico = !$this.reloadHistorico;
                            $this.reloadNavegacao();
                            $this.selecionaArtefato(parseInt(res.data.data));
                        } else {
                            console.log(res.data.msg);
                            $this.flReprocessar = true;
                            avisoErro("Não foi possível enviar o artefato.");
                        }
                    })
                    .catch(res => {
                        $this.flReprocessar = true;
                        $this.statusArtefato = 'Cancelada';
                        $this.msgErro = 'Não foi possível enviar o artefato.';
                        if (res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível enviar o artefato.");
                        }
                    });
            },

            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/Artefato/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        $this.flVerificouUtilizacoes = true;
                        if (res.data.success) {
                            $this.utilizacoes = res.data.data;
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de artefatos.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de artefatos.");
                        }
                        $this.loading.hide();
                    });
            },

            verificaRealizaArtefato() {
                let $this = this;
                axios.get(`${urlApi}/Artefato/VerificaRealizarArtefato`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.flRealizaArtefato = res.data.data;
                            $this.flVerificouRealizar = true;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            carregaArtefato() {
                let $this = this;
                axios.get(`${urlApi}/Artefato/Get/${$this.idArtefato}`)
                    .then(res => {
                        $this.artefato = null;
                        if (res.data.success) {
                            var result = res.data.data;

                            var status = '';
                            if (result.lstArtefatoMovimento.length > 0) {
                                status = result.lstArtefatoMovimento[result.lstArtefatoMovimento.length - 1].dsMovimento;
                                $this.statusArtefato = status;
                            }

                            $this.artefato = {
                                idArtefato: result.artefato.idArtefato,
                                dsLogin: result.artefato.dsLogin,
                                dsNome: result.artefato.dsNome,
                                dtInclusao: moment(result.artefato.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                nmModelo: result.modeloArtefato.nmModelo,
                                status: status,
                                solicitante: result.solicitante,
                                modelo: result.modeloArtefato,
                                documento: result.documento,
                                dsResposta: result.artefato.dsResposta,
                                urlArquivo: result.artefato.urlArquivo,
                                nmLegislacao: (result.modeloArtefato.idLegislacaoModeloArtefato == 1 ? "14.133" :"13.303"),
                            };

                            if (result.modeloArtefato.idLegislacaoModeloArtefato) {
                                $this.getLegislacao(result.modeloArtefato.idLegislacaoModeloArtefato == 1 ? 1: 3);
                            }
                        } else {
                            avisoErro("Não foi possível carregar o artefato.");
                        }

                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("erro");
                        }
                        $this.loading.hide();
                    });
            },

            getLegislacao(idLegislacao) {
                let $this = this;
                axios.get(`${urlApi}/Legislacao/Get/${idLegislacao}`)
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.legislacao = result;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            downloadArtefato(idArtefatoMovimento,urlArquivo) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1].slice(10);
                }
                axios({
                    url: `${urlApi}/Artefato/DownloadDocumento/${idArtefatoMovimento}`, //your url
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        // create file link in browser's memory
                        const href = URL.createObjectURL(response.data);

                        // create "a" HTML element with href to file & click
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', nmArquivo); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        // clean up "a" element & remove ObjectURL
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            download(urlArquivo,flNome = false) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    if (flNome) {
                        nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    } else {
                        nmArquivo = nomeArquivo[nomeArquivo.length - 1].slice(7);
                    }
                }
                
                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },

            getNomeArquivo(urlArquivo) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1].slice(7)
                    return nmArquivo;
                } else {
                    return "daods";
                }
            },

            openReferencia(cdConteudo, idItemPesquisa, dsReferencia) {
                this.modalDetalhes = {
                    cdConteudo: cdConteudo,
                    idItemPesquisa: idItemPesquisa,
                    dsReferencia: dsReferencia,
                };
                this.showModalDetalhes = !this.showModalDetalhes;
            },

            getDataBs(item) {
                return ` <span class="mb-0"> ${(item.modeloArtefato.dsModelo != null ? item.modeloArtefato.dsModelo:item.modeloArtefato.nmModelo)}</span> 
                `;
            },

            montaPopover() {
                window.$(".popover").each(function () {
                    window.$(this).remove();
                });
                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popoverModelo"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    placement: "top",
                                });
                            });
                    }
                });
            },

        },
        mounted: function () {
            this.load();

            if (this.hubConection != undefined) {
                // signalR
                this.InitSignalR();
            }
            
        },
        watch: {
            reload: function () {
                this.novo();
            },

            idLegislacaoModeloArtefato: function () {
                this.idModelo = null;
                this.carregaModelos();
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .btn-selecionar {
        border-color: #f5f5f5 !important;
    }
</style>

